export default class Events {

    constructor() {
        this.observers = [];

    }

    initNyelvvalaszto()
    {
        $('header .nyelvvalaszto .display, header .nyelvvalaszto .nyil').on('click', e => {
            $(e.currentTarget).parent().toggleClass('opened');
        });
    }

    initValtakozoSzoveg()
    {
        if ($('.valtakozo-szovegek').length > 0)
        {
            var step = 2600, aktTimer = 0;
            var repetEffect = () => {
                $('.valtakozo-szovegek span').each(function (ind, el) {
                    setTimeout(() => {
                        $('.valtakozo-szovegek span').removeClass('active');
                        setTimeout(() => {
                            $(el).addClass('active')
                        }, 600);
                    }, aktTimer);
                    aktTimer += step;
                })
            };
            setInterval(() => {
                repetEffect()
            }, aktTimer);

        }
    }

    initMenuLinks()
    {
        $('header .menu-links-kont .menu-links a, .tovabblink-dobozzal-kont a, .footer-popup-button').on('click', e => {
            let target = $('[data-slide="' + $(e.currentTarget).data('target') + '"]');
            if ($(target).length > 0)
            {
                e.preventDefault();
                $("html, body").stop().animate({ scrollTop: target.offset().top - 0 }, '150');
            }
            $('header .header-center .hamburger').removeClass('open');
            $('header .header-center nav').removeClass('open');
        });

        $('header .header-center .hamburger').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $('header .header-center nav').toggleClass('open');
        });

        if (window.location.hash) {
            let baseLnk = $('header .menu-links-kont .menu-links a[href*="' + window.location.hash + '"]');
            if ($(baseLnk).length > 0)
            {
                let target = $('[data-slide="' + $(baseLnk).data('target') + '"]');
                if ($(target).length > 0)
                {
                    $("html, body").stop().animate({ scrollTop: target.offset().top - 0 }, '150');
                }
            }
        }

        // a safari miatt a videó elindítása
        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)
        {
            $('.slide.slide-1').each(function(i, sl) {
                $(sl).on('click', function() {
                    const vid = $(this).find('video');
                    if (vid.length > 0)
                    {
                        vid.get(0).play();
                    }
                });
            })
        }

    }

    initAnimClassSetup()
    {
        const slides = document.querySelectorAll('section.slide');
        for (const slide of slides) {

            let thresholdValue = 0.1;
            if ($(slide).hasClass('slide-4'))
            {
                thresholdValue = 0.1;
            }

            let observer = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting === true)
                {
                    $(entries[0].target).addClass('animation-on');

                    $('body').data('aktslide', $(slide).data('slide'));


                    if ($('body').data('aktslide') == 'kapcsolat')
                    {
                        $('.footer-popup-button').addClass('off');
                    } else {
                        $('.footer-popup-button').removeClass('off');
                    }

                    // ha van video a slide-on újra induljon el
                    let vid = $(slide).find('video');
                    if (vid.length > 0)
                    {
                        vid.get(0).pause();
                        vid.get(0).currentTime = 0;
                        vid.get(0).play();
                    }

                    // url hash megkeresése és megváltoztatása, csak a címlapon
                    if ($('.slide.mainpage').length > 0)
                    {
                        $('header .menu-links-kont .menu-links a').each((i, lnk) => {
                            if ($('body').data('aktslide') == 'slide1') {

                                if (window.history.pushState)
                                {
                                    window.history.pushState({}, '', '#');
                                } else {
                                    window.location.hash = '#';
                                }

                                $('header .menu-links-kont .menu-links a').removeClass('active');
                            } else {
                                if ($(lnk).data('target') == $('body').data('aktslide')) {
                                    let lnkHash = $(lnk).attr('href').replace(/^.+(\#.+)$/, "$1");
                                    if (window.history.pushState)
                                    {
                                        window.history.pushState({}, '', lnkHash);
                                    } else {
                                        window.location.hash = lnkHash;
                                    }

                                    $(lnk).addClass('active');
                                } else {
                                    $(lnk).removeClass('active');
                                }
                            }


                        })



                    }


                } else {
                    $(entries[0].target).removeClass('animation-on');

                }
            }, { threshold: [thresholdValue] });

            observer.observe(slide);
            this.observers.push(observer);
        }

        // menu ragadósdi, csak ahol több slide van
        if ($('section').length > 1)
        {
            // menu ragadósra váltás
            let observerMenuOn = new IntersectionObserver(function (entries) {
                if (entries[0].isIntersecting === true) {
                    $('header').removeClass('topstick');
                } else {
                    $('header').addClass('topstick');
                }
            }, { threshold: [0.01] });
            observerMenuOn.observe(document.querySelector('section.slide-1'));
            this.observers.push(observerMenuOn);

            if ($('body').data('aktslide') != 'slide1')
            {
                $('header').addClass('topstick');
            }

        }

        // slide 4 referenciák
        if ($('section.slide-4').length > 0)
        {
            const slides_cards = document.querySelectorAll('section.slide-4 .project-card');
            for (const card of slides_cards) {

                let observer = new IntersectionObserver(function (entries) {
                    if (entries[0].isIntersecting === true)
                    {
                        $(entries[0].target).addClass('animation-on');
                    } else {
                        $(entries[0].target).removeClass('animation-on');
                    }
                }, { threshold: [0.2] });

                observer.observe(card);
                this.observers.push(observer);
            }
        }

    }

    initKapcsolatForm()
    {
        if ($('.slide-kapcsolat form').length == 0)
        {
            return false;
        }

        const baseForm = $('.slide-kapcsolat form');

        $('.form-item.submit button', baseForm).on('click', e => {

            let validateResult = this.kapcsolatFormCheck(baseForm);

            if (validateResult.error)
            {
                this.drawErrors(validateResult.errors, baseForm.parent());
            } else {
                $(e.currentTarget).attr('disabled', true);
                baseForm.addClass('waiting');
                $.post('/', baseForm.serialize(), response => {
                    baseForm.removeClass('waiting');
                    $(e.currentTarget).removeAttr('disabled');

                    if (response.send_result.error)
                    {
                        $('.send-results-success', baseForm).addClass('error');
                        $('.send-results-success', baseForm).text(response.send_result.msg);
                    } else {
                        $('.send-results-success', baseForm).text(
                            $('.send-results-success', baseForm).data('base-message')
                        );

                        $(':text, textarea', baseForm).val('');
                    }

                    $('.send-results-success', baseForm).addClass('open');
                    setTimeout(() => { $('.send-results-success', baseForm).removeClass('open error'); }, 5000);
                })
            }
        })
    }

    initProjectCards()
    {
        $('section.slide-4 .project-card').each(function () {
            $(this).on('click', function () {

                let target = $(this).data('click-target');
                if (target != "")
                {
                    document.location.href = target;
                }
            })
        })

    }


    kapcsolatFormCheck(baseForm)
    {
        var error = false;
        var errorobj = [];

        if ($("#nev", baseForm).val().trim() == "")
        {
            error = true;
            errorobj.push({ msg: $('#nev', baseForm).data('error-empty'), baseObject: $('#nev', baseForm).parent() });
        }

        if ($("#email", baseForm).val().trim() == "")
        {
            error = true;
            errorobj.push({ msg: $('#email', baseForm).data('error-empty'), baseObject: $('#email', baseForm).parent() });
        } else {
            let emailReg = /^\S+@\S+\.\S+$/;
            if (!emailReg.test($('#email', baseForm).val().trim()))
            {
                error = true;
                errorobj.push({msg: $('#email', baseForm).data('error-invalid'), baseObject: $('#email', baseForm).parent() });
            }
        }

        return {
            'error': error,
            'errors': errorobj
        }
    }

    drawErrors(errors, basePage) {

        $('.errormsg', basePage).each(function () { $(this).remove()});
        $('.errorstate', basePage).each(function () { $(this).removeClass('errorstate') });

        for (let errO of errors)
        {
            let errMsg = $('<div>').addClass('errormsg').text(errO.msg);
            errO.baseObject.append(errMsg);
            errO.baseObject.addClass('errorstate');
        }
    }

}

